import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";
export default function TimeCompo() {
  const [times, setTimes] = useState({
    uk: '',
    nigeria: '',
    india: '',
  });

  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  //  useEffect(() => {
  //    const adminId = localStorage.getItem("adminID");
  //    if (!adminId) {
  //      navigate("/"); 
  //    }
 
  //    // 👇 load dark mode preference
  //    const savedTheme = localStorage.getItem("darkMode") === "true";
  //    setDarkMode(savedTheme);
  //    document.body.classList.toggle("dark", savedTheme);
  //  }, [navigate]);


  useEffect(() => {
    const updateTimes = () => {
      const uk = moment().tz("Europe/London").format("hh:mm:ss A");
      const nigeria = moment().tz("Africa/Lagos").format("hh:mm:ss A");
      const india = moment().tz("Asia/Kolkata").format("hh:mm:ss A");

      setTimes({ uk, nigeria, india });
    };

    updateTimes(); // Initial load
    const interval = setInterval(updateTimes, 1000); // Update every second

    return () => clearInterval(interval); // Clean up
  }, []);

  return (
    <div className="d-flex gap-2 text-nowrap">
      <span className={`badge rounded-pill mainttl ${darkMode ? "dark" : ""}   px-3 py-2 small-label time`}>
        {/* <i className="bi bi-clock me-1"></i>  */}
        <span className={`time2 mainttl ${darkMode ? "dark" : ""}`}>UK:</span> {times.uk}
      </span>
      <span className={`badge rounded-pill mainttl ${darkMode ? "dark" : ""}   px-3 py-2 small-label time`}>
        <span className={`time2 mainttl ${darkMode ? "dark" : ""}`}>Nigeria:</span> {times.nigeria}
      </span>
      <span className={`badge rounded-pill mainttl ${darkMode ? "dark" : ""}   px-3 py-2 small-label time`}>
       <span className={`time2 mainttl ${darkMode ? "dark" : ""}`}>India:</span> {times.india}
      </span>
    </div>
  );
}
